<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("customerloyaltyponits") }}</div>
        <!-- <div class="section-subTitle my-2">Manage all Customer Loyalty Points</div> -->
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-debounce:300="getCustomerLoyaltyPoints"
          v-model="searchValue"
          :placeholder="$tc('searchs')"
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="mx-2">
          <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content>
              {{ $t('viewing') }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;{{ $t('of') }}&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              v-if="parseInt(list.name) <= rows || list.name === 'All'"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <!-- LIST VIEW DESIGNATION -->
    <div class="white-wrapper">
      <div class="swc-report">
        <table class="swc-report-table">
          <thead class>
            <tr>
              <th>{{ $t("customer") }} {{ $t("name") }}</th>
              <th>{{ $t("earnpoints") }}</th>
              <th>{{ $t("burnpoints") }}</th>
              <th>{{ $t("totalpoints") }}</th>
              <th>{{$t("boxoffice")}} <br/> {{ $t("transactions")}}</th>
              <th>{{$t("FnB")}} <br/> {{ $t("transactions")}}</th>
            </tr>
          </thead>

          <tbody v-if="customerloyaltypoints.length > 0">
            <tr
              v-for="(customerlist, customerlistIndex) in customerloyaltypoints"
              :key="customerlistIndex"
              class="light_grey_back"
            >
              <td class="text-left">
                {{ customerlist.first_name }} {{ customerlist.last_name }}
              </td>
              <td v-if="customerlist.total_earning_points != null " class="text-right">
                {{ customerlist.total_earning_points }}
              </td>
              <td v-else>-</td>
              <td v-if="customerlist.total_burning_points != null" class="text-right">
                {{ customerlist.total_burning_points }}
              </td>
              <td v-else>-</td>
              <td class="text-right">{{ customerlist.total_points }}</td>
              <td>
                <router-link
                  variant="default"
                  :to="
                    '/marketing/view-customer-loyalty-points?clp_id=' +
                    customerlist.cust_id + '&type=boxoffice'
                  "
                  class="btn-blue p-2"
                  >{{ $t("view") }} </router-link
                >
              </td>
              <td>
                <router-link
                  variant="default"
                  :to="
                    '/marketing/view-customer-loyalty-points?clp_id=' +
                    customerlist.cust_id + '&type=fnb'
                  "
                  class="btn-blue p-2"
                  >{{ $t("view") }}  </router-link
                >
              </td>
            </tr>
          </tbody>

          <tbody v-else>
            <tr>
              <td colspan="6">
                <!-- No Records Found. -->
                <NoRecords/>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <br />
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>


<script>
import MarketingService from "@/services/MarketingService";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components:{
    NoRecords
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [],
      customerloyaltypoints: [],

      debounce: null,
      searchValue: "",
    };
  },
  beforeMount() {
    this.getCustomerLoyaltyPoints();
    this.getviewingnumber();
  },
  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
      } else {
        this.selectedvalue = event;
        this.perPage = event;
      }
      this.onChangePagination();
    },
    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getCustomerLoyaltyPoints();
      } else {
        this.currentPage = event;
        this.getCustomerLoyaltyPoints();
      }
    },
    getCustomerLoyaltyPoints: function () {
      let body = {
        limit: this.perPage,
        currentPage: this.currentPage,
        searchValue: this.searchValue,
      };

      let loader = this.$loading.show();

      MarketingService.GetCustomerLoyaltyPoints(body)
        .then((response) => {
          const { data } = response;

          if (data.status) {
            if (data.Records && data.Records.length > 0) {
              this.customerloyaltypoints = data.Records;

              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                // this.selectedvalue = data.totalRows;
              }
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          loader.hide();
        });
    },
    /* eslint-disable */
    onViewUser: function (user) {
      this.$router.push({
        path: "/user-management/view-user",
        query: { user_id: user.user_id },
      });
    },
  },
};
</script>

<style scoped>
.swc-report .swc-report-table th,
td {
  border-bottom: 1px solid #000000;
}

.swc-report .swc-report-table {
  border: none !important;
}
</style>




// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/CustomerLoyaltyPointsComponents/listcustomerloyaltypoints.vue